import { render, staticRenderFns } from "./SSNewsEditor.vue?vue&type=template&id=c8033afe&scoped=true&"
import script from "./SSNewsEditor.vue?vue&type=script&lang=js&"
export * from "./SSNewsEditor.vue?vue&type=script&lang=js&"
import style0 from "./SSNewsEditor.vue?vue&type=style&index=0&id=c8033afe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8033afe",
  null
  
)

export default component.exports